import { CommentHeader as AntdCommentHeader } from "@empglabs/backoffice-ui-kit"

export const CommentHeader = props => {
  return <AntdCommentHeader {...props} />
}
